import React, { useId } from 'react';
import { Controller } from 'react-hook-form';
import { Dropdown, type DropdownProps } from 'primereact/dropdown';
import { type BaseFormInputProps } from '@/Type/BaseFormInputProps';
import { fieldsPlaceholders } from '@/Config/forms';
import ErrorsBlock from "@/Components/Forms/Form/ErrorsBlock";


export type BaseDropDownPt = {
    pt?: {
        dropdown?: {
            className?: string;
        }
    }
};

export type BaseDropdownProps = DropdownProps & BaseFormInputProps & BaseDropDownPt;

const BaseDropdown: React.FC<BaseDropdownProps> = ({
    control,
    label,
    errorMessages,
    className,
    required,
    pt,
    ...props
}: BaseDropdownProps) => {
    const localId = useId();

    return (
        <div className={className}>
            {
                label && <label className="block mb-2" htmlFor={localId}>{label}{required ? '*' : ''}</label>
            }
            {
                control && props.name &&
                <Controller
                    name={props.name}
                    control={control}
                    disabled={props.disabled}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            id={localId}
                            name={field.name}
                            invalid={fieldState.invalid}
                            value={field.value}
                            options={props.options ?? []}
                            disabled={field.disabled}
                            placeholder={props.placeholder ?? fieldsPlaceholders.dropdown}
                            onChange={(e) => {
                                field.onChange(e.value);
                                if (props.onChange) {
                                    props.onChange(e);
                                }
                            }}
                            onBlur={(e) => {
                                field.onBlur();
                                if (props.onBlur) {
                                    props.onBlur(e);
                                }
                            }}
                            {...props}
                            {...pt?.dropdown}
                        />
                    )}
                />
            }
            {
                !control &&
                <Dropdown
                    id={localId}
                    {...props}
                    {...pt?.dropdown}
                />
            }
            <ErrorsBlock
                className="block mt-2 p-error"
                errorMessages={errorMessages}
            />
        </div>
    );
};

export default BaseDropdown;
